import { render, staticRenderFns } from "./customButton.vue?vue&type=template&id=16549228&scoped=true"
import script from "./customButton.vue?vue&type=script&lang=ts"
export * from "./customButton.vue?vue&type=script&lang=ts"
import style0 from "./customButton.vue?vue&type=style&index=0&id=16549228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16549228",
  null
  
)

export default component.exports